(function () {
  'use strict';

  var SHEETS_URL =
    'https://script.google.com/macros/s/AKfycbzPl4ntBq2DV3ZQmPu5NvjZwZtlluILA6ckmelFNoORt0m4M0_RBqgvFnCld3w1iACo/exec';

  function sendToSheets(data) {
    return fetch(SHEETS_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    });
  }

  function fd(formData, key) {
    return formData.get(key) || '';
  }

  // ── Contact Page Form (sections/main-contact.liquid & sections/contact-form.liquid) ──
  function handleContactForm(form) {
    form.addEventListener('submit', function () {
      var formData = new FormData(form);
      var nameEl    = document.getElementById('ContactForm-name');
      var emailEl   = document.getElementById('ContactForm-email');
      var phoneEl   = document.getElementById('ContactForm-phone');
      var subjectEl = document.getElementById('ContactForm-subject');
      var bodyEl    = document.getElementById('ContactForm-body');

      var data = {
        form_type: 'contact',
        name:    nameEl    ? nameEl.value    : fd(formData, 'contact[Naam]'),
        email:   emailEl   ? emailEl.value   : fd(formData, 'contact[email]'),
        phone:   phoneEl   ? phoneEl.value   : fd(formData, 'contact[Telefoonnummer]'),
        subject: subjectEl ? subjectEl.value : fd(formData, 'contact[Onderwerp]'),
        message: bodyEl    ? bodyEl.value    : fd(formData, 'contact[Reactie]'),
        page:    window.location.href,
      };

      // Fire-and-forget to Google Sheets; let the native Shopify submit continue for email
      sendToSheets(data);
    });
  }

  // ── Product Offerte Modal Form (snippets/custom-project-cta.liquid) ──
  function handleProjectForm(form) {
    form.addEventListener('submit', function () {
      var formData = new FormData(form);
      var data = {
        form_type: 'offerte',
        product:   fd(formData, 'contact[Product]'),
        name:      fd(formData, 'contact[Naam]'),
        email:     fd(formData, 'contact[email]'),
        phone:     fd(formData, 'contact[Telefoonnummer]'),
        company:   fd(formData, 'contact[Bedrijf]'),
        street:    fd(formData, 'contact[Straat en huisnummer]'),
        zip:       fd(formData, 'contact[Postcode]'),
        city:      fd(formData, 'contact[Stad]'),
        message:   fd(formData, 'contact[Reactie]'),
        page:      window.location.href,
      };

      // Fire-and-forget to Google Sheets; let the native Shopify submit continue for email
      sendToSheets(data);
    });
  }

  // ── Initialise all forms on the current page ──
  function init() {
    var contactForm = document.getElementById('ContactForm');
    if (contactForm && !contactForm.dataset.sheetsReady) {
      contactForm.dataset.sheetsReady = '1';
      handleContactForm(contactForm);
    }

    document.querySelectorAll('.custom-project-modal__form').forEach(function (form) {
      if (!form.dataset.sheetsReady) {
        form.dataset.sheetsReady = '1';
        handleProjectForm(form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when a modal is opened (forms may not have been initialised yet)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-open]')) {
      setTimeout(init, 50);
    }
  });
})();
